import { historyConstants } from "../_constants";

export const transactionHistoryListRequest = (payload) => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_LIST_REQUEST,
    payload,
  };
};

export const transactionHistoryListComplete = (payload) => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_LIST_COMPLETE,
    payload,
  };
};

export const transactionHistoryDetailRequest = (payload) => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_DETAIL_REQUEST,
    payload,
  };
};

export const transactionHistoryDetailComplete = (payload) => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_DETAIL_COMPLETE,
    payload,
  };
};

export const transactionHistoryDetailError = (payload) => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_DETAIL_ERROR,
    payload,
  };
};

export const transactionHistoryDetailRemove = () => {
  return {
    type: historyConstants.TRANSACTION_HISTORY_DETAIL_REMOVE,
  };
};
